{
	"noInternet": "No internet connection. Some actions are temporarily unavailable."
}
